/* GENERAL COLDRES — menus progressivos + busca robusta */
if (!customElements.get('gc-header')) {
  customElements.define('gc-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const opened = event.target.closest('details[open]');
        if (opened && this.contains(opened)) {
          opened.open = false;
          opened.querySelector(':scope > summary')?.focus();
          event.preventDefault();
          event.stopPropagation();
        }
      }, options);

      this.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        if (!summary) return;

        const sync = () => summary.setAttribute('aria-expanded', String(details.open));
        sync();

        details.addEventListener('toggle', () => {
          sync();
          if (!details.open) return;

          const scope = details.closest('ul');
          if (scope) {
            scope.querySelectorAll(':scope > li > details').forEach((sibling) => {
              if (sibling !== details) sibling.open = false;
            });
          }

          if (details.classList.contains('gc-header__search-pop')) {
            this.querySelectorAll('.gc-header__menu-trigger[open], .gc-header__nav details[open]').forEach((item) => {
              item.open = false;
            });
            requestAnimationFrame(() => {
              const input = details.querySelector('input[type="search"]');
              input?.focus({ preventScroll: true });
            });
          }
        }, options);
      });

      this.querySelectorAll('[data-gc-search-form]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          const input = form.querySelector('input[name="q"]');
          const query = input?.value?.trim() || '';

          if (!query) {
            event.preventDefault();
            input?.focus();
            return;
          }

          event.preventDefault();
          const url = new URL(form.action, window.location.origin);
          const data = new FormData(form);
          data.set('q', query);
          for (const [key, value] of data.entries()) {
            url.searchParams.set(key, value);
          }
          window.location.assign(url.toString());
        }, options);
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeMenus();
      }, options);

      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeMenus();
      }, options);

      this.media = matchMedia('(min-width: 990px)');
      this.media.addEventListener('change', () => this.closeMenus(), options);
    }

    closeMenus() {
      this.querySelectorAll('details[open]').forEach((el) => { el.open = false; });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}


/* Fallback robusto para qualquer formulário de busca General, inclusive /search. */
document.addEventListener('submit', (event) => {
  const form = event.target.closest('form[data-gc-search-form]');
  if (!form || form.closest('gc-header')) return;

  const input = form.querySelector('input[name="q"]');
  const query = input?.value?.trim() || '';

  event.preventDefault();

  if (!query) {
    input?.focus();
    return;
  }

  const url = new URL(form.action, window.location.origin);
  const data = new FormData(form);
  data.set('q', query);

  for (const [key, value] of data.entries()) {
    url.searchParams.set(key, value);
  }

  window.location.assign(url.toString());
});
